import tippy from 'tippy.js';

export const initTooltips = () => {
  tippy('.js-tooltip:not(.is-loaded)', {
    content(reference) {
      reference.classList.add('is-loaded');
      if (reference.firstElementChild && reference.firstElementChild.tagName === 'svg') {
        const title = reference.querySelector('title');
        const text = title.textContent;
        title.remove();
        return text;
      }

      return reference.dataset.content;
    },
    // dev options
    // hideOnClick: false,
    // trigger: 'click',
  });
}
